import { UsuarioComisionFreelanceTarifaService } from './../../../_services/usuario-comision-freelance-tarifa.service';
import { UsuarioComisionFreelanceService } from './../../../_services/usuario-comision-freelance.service';
import { NavService } from './../../../_services/_nav.service';
import { UsuarioComisionFreelance } from './../../../_models/usuario-comision-freelance';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UsuarioComisionFreelanceTarifa } from '../../../_models/usuario-comision-freelance-tarifa';
@Component({
  selector: 'app-comision-freelance-detalle',
  templateUrl: './comision-freelance-detalle.component.html',
  styleUrls: ['./comision-freelance-detalle.component.css']
})
export class ComisionFreelanceDetalleComponent implements OnInit {

  comisionFreelance: UsuarioComisionFreelance;
  comisionFreelanceTarifas: UsuarioComisionFreelanceTarifa[] = [];
  carInformacionInicial = true;

  colComisionFreelanceTarifas = [];

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private nav: NavService,
    private usuarioComisionFreelanceService: UsuarioComisionFreelanceService,
    private usuarioComisionFreelanceTarifaService: UsuarioComisionFreelanceTarifaService
  ) { }

  ngOnInit() {

    this.colComisionFreelanceTarifas = [
      { field: 'rangoInferior', header: this.nav.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOINFERIOR' ), sort: false },
      { field: 'rangoSuperior', header: this.nav.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_RANGOSUPERIOR' ), sort: false },
      { field: 'porcentajeAplicado', header: this.nav.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJEAPLICADO' ), sort: false },
      { field: 'porcentajeTarifa', header: this.nav.buscarMensaje( 'USUARIOCOMISIONFREELANCETARIFA.LBL_PORCENTAJETARIFA' ), sort: false },
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.usuarioComisionFreelanceService.obtenerPorId( params[ 'id' ] ),
        this.usuarioComisionFreelanceTarifaService.listadoPorUsuarioFreelance(params[ 'id' ])
      ).subscribe( ( [ comisionFreelance, comisionFreelanceTarifas] ) => {
        this.comisionFreelance = comisionFreelance;
        this.comisionFreelanceTarifas = comisionFreelanceTarifas;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }

}
